import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import Cookies from 'js-cookie'
import MessageConstants from '../../../constants/MessageConstants.js'
import API from '../../../api/auth'

class OAuthLogin extends Component {

  constructor(props) {
    super(props)

    const defaultMessage = this.props.location.state ? this.props.location.state.message || '' : ''

    this.state = {
      error: null,
      email: '',
      password: '',
      message: defaultMessage
    }

    this.handleEmailInput = this.handleEmailInput.bind(this)
    this.handlePasswordInput = this.handlePasswordInput.bind(this)
    this.submitLogin = this.submitLogin.bind(this)

    //this replaces the persisted message state.
    //in react router
    setTimeout( ()=>{
      this.setState({message: ''})
    }, 5000)
  }

  componentDidMount = () => {
    const { clientId, redirectURI } = this.props
    const token = Cookies.get('DrifttAuth')
    if(!!token) {
      API.fetchOAuthCode(token, clientId, redirectURI, this.setCode)
    }
  }

  submitLogin(event) {
    event.preventDefault()

    const loginCallback = (response) => {
      if (response.status === 200){
        API.fetchOAuthCode(response.data.access_token, this.props.clientId, this.props.redirectURI, this.setCode)
      } else if (response.status === 400) {
        this.setState({ error: MessageConstants.LOGIN_BAD_INPUT })
      } else {
        this.setState({ error: MessageConstants.DEFAULT_SERVER_ERROR })
      }
    }

    API.oauthLogin(this.state.email, this.state.password, loginCallback.bind(this))
  }

  setCode = (response) => {
    if (response.status === 200){
      this.props.setCode(response.data.code)
    }
  }

  handleEmailInput(event) {
    this.setState({email: event.target.value, error: ''})
  }

  handlePasswordInput(event) {
    this.setState({password: event.target.value, error: ''})
  }

  render() {
    const { error, message } = this.state

    return (
      <div className="login-page">
        <p className="success-message">{ message }</p>
        <p>Need a Drift account? <Link to={{pathname: '/authorize/quick-start', search: location.search }}>Create a Drift account.</Link></p>
        <form className="drift-form" onSubmit={this.submitLogin}>
          <input onChange={this.handleEmailInput} className="large" type="email" placeholder="your email" required/>
          <input onChange={this.handlePasswordInput} className="large" type="password" placeholder="your password" required />
          {error && <strong className="request-status error">{ error }</strong> }
          <button className="drift-button drift-button-primary medium" type="submit">Log In</button>
        </form>
        <Link to={{pathname: "/forgot-password", state: { email: this.state.email }}} className="solo-link">I forgot my password</Link>
      </div>
    )
  }
}

const OAuthLoginPage = withRouter(OAuthLogin)

export default OAuthLoginPage



// WEBPACK FOOTER //
// ./src/components/pages/OAuthLogin/index.js